import { useState, useEffect } from 'react';
import axios from '../utils/axios';
import { getSettingsImage } from '../utils/imageHelpers';

const RingSizeGuide = () => {
    const [content, setContent] = useState('');
    const [image, setImage] = useState('');
    const [loading, setLoading] = useState(true);
    const [selectedMm, setSelectedMm] = useState('');
    const [result, setResult] = useState(null);

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            const { data } = await axios.get('/settings');
            setContent(data.ringSizeGuide || 'İçerik hazırlanıyor...');
            setImage(data.ringSizeGuideImage || '');
        } catch (error) {
            setContent('İçerik yüklenemedi.');
        } finally {
            setLoading(false);
        }
    };

    const calculateSize = () => {
        if (selectedMm) {
            setResult(selectedMm);
        }
    };

    if (loading) {
        return (
            <div className="max-w-4xl mx-auto px-4 py-16">
                <div className="flex items-center justify-center h-64">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20">
                <h1 className="font-serif text-4xl md:text-5xl font-light tracking-wide text-center mb-12">
                    Yüzük Ölçüsü Nasıl Alınır?
                </h1>

                {/* Calculator Section */}
                <div className="bg-gray-50 rounded-2xl p-8 mb-16 shadow-sm border border-gray-100">
                    <div className="flex flex-col gap-12">
                        {/* Dynamic Image - Full Width for better visibility */}
                        {image && (
                            <div className="w-full bg-white p-4 rounded-xl border border-gray-100 shadow-sm">
                                <img
                                    src={getSettingsImage(image)}
                                    alt="Yüzük Ölçüsü Rehberi"
                                    className="w-full h-auto rounded-lg"
                                />
                                <p className="text-center text-sm text-gray-400 mt-3 font-light italic">
                                    * Lütfen ölçüm yaparken yukarıdaki görseli referans alınız.
                                </p>
                            </div>
                        )}

                        {/* Calculator - Centered */}
                        <div className="max-w-md mx-auto w-full text-center">
                            <h3 className="font-serif text-2xl mb-2 text-gray-900">Ölçü Hesaplama</h3>
                            <p className="text-gray-500 mb-8 font-light">
                                Cetvel ile ölçtüğünüz yüzük çapını seçerek numaranızı bulun.
                            </p>

                            <div className="space-y-6 text-left">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">
                                        Ölçü Birimi (Çap - mm)
                                    </label>
                                    <select
                                        className="w-full p-3 border border-gray-300 rounded-lg focus:ring-primary focus:border-primary transition"
                                        value={selectedMm}
                                        onChange={(e) => {
                                            setSelectedMm(e.target.value);
                                            setResult(null); // Reset result on change
                                        }}
                                    >
                                        <option value="" disabled>Seçiniz</option>
                                        <option value="7">14.8 mm</option>
                                        <option value="8">15.3 mm</option>
                                        <option value="9">15.7 mm</option>
                                        <option value="10">16.0 mm</option>
                                        <option value="11">16.3 mm</option>
                                        <option value="12">16.5 mm</option>
                                        <option value="13">16.9 mm</option>
                                        <option value="14">17.3 mm</option>
                                        <option value="15">17.7 mm</option>
                                        <option value="16">18.2 mm</option>
                                        <option value="17">18.5 mm</option>
                                        <option value="18">18.9 mm</option>
                                        <option value="19">19.4 mm</option>
                                        <option value="20">19.8 mm</option>
                                        <option value="21">20.0 mm</option>
                                        <option value="22">20.2 mm</option>
                                        <option value="23">20.3 mm</option>
                                        <option value="24">20.5 mm</option>
                                        <option value="25">20.8 mm</option>
                                        <option value="26">21.0 mm</option>
                                        <option value="27">21.3 mm</option>
                                        <option value="28">21.6 mm</option>
                                        <option value="29">22.0 mm</option>
                                        <option value="30">22.4 mm</option>
                                    </select>
                                </div>

                                <button
                                    onClick={calculateSize}
                                    disabled={!selectedMm}
                                    className="w-full btn-primary py-3 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    HESAPLA
                                </button>

                                {result && (
                                    <div className="mt-6 p-4 bg-primary/10 border border-primary/20 rounded-lg text-center animate-fade-in">
                                        <span className="text-gray-600 block text-sm mb-1">Yüzük Ölçünüz</span>
                                        <span className="text-4xl font-serif text-primary font-medium">{result}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Text Content */}
                <div className="prose prose-lg max-w-none">
                    <div
                        className="text-gray-600 font-light leading-relaxed whitespace-pre-wrap [&_p]:mb-6"
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                </div>
            </div>
        </div>
    );
};

export default RingSizeGuide;
